import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Kompetenzen from "./components/Kompetenzen";
import VideoSection from "./components/VideoSection";
import BookingSection from "./components/BookingSection";
import Footer from "./components/Footer";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";
import AGB from "./components/AGB";
import CookieBanner from "./components/CookieBanner";
import { ModeProvider } from "./contexts/ModeContext";
import { initializeCookieManager } from "./utils/cookieManager";
import { initializeAccessibility } from "./utils/accessibility";
import "./index.css";

function Landing() {
  return (
    <>
      <main id="main-content" role="main" style={{ textAlign: 'left', width: '100%' }}>
        <Hero />
        <Kompetenzen />
        <VideoSection />
        <BookingSection />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    // Initialize cookie management system
    initializeCookieManager();
    
    // Initialize accessibility features for EAA 2025 compliance
    initializeAccessibility();
  }, []);

  return (
    <div className="min-h-screen" style={{ textAlign: 'left', width: '100%' }}>
      <BrowserRouter>
        <ModeProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/impressum" element={<><Impressum /><Footer /></>} />
            <Route path="/datenschutz" element={<><Datenschutz /><Footer /></>} />
            <Route path="/agb" element={<><AGB /><Footer /></>} />
          </Routes>
          <CookieBanner />
        </ModeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;